export const SET_EXTERNALAPINAME = 'SET_EXTERNALAPINAME';
export const SET_EXTERNALAPIDESCRIPTION = 'SET_EXTERNALAPIDESCRIPTION';
export const SET_EXTERNALAPICOMPANYID = 'set_EXTERNALAPICOMPANYID';
export const SET_EXTERNALAPIKEY = 'SET_EXTERNALAPIKEY';
export const SET_EXTERNALAPIITEMS = 'SET_EXTERNALAPIITEMS';
export const SET_EXTERNALAPIID = 'SET_EXTERNALAPIID';